// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"371":"ae6635ed","394":"2c5e67a5","452":"88a7a66d","501":"e75a107b","629":"084b6f83","872":"572d7494"}[chunkId] + ".chunk.css";
};